import { createContext } from 'react';
export const RecoilReduxContext = createContext({});
//# sourceMappingURL=context.js.map